module.exports = __webpack_public_path__ + "static/media/large_custom_pens.a0c3dc61.jpg";